<template>
    <div>
        <section>
            <div class="top-nav-div">
                <div class="top-nav-elements">
                    <a href="#" class="link-block-42 w-inline-block">
                        <img :src="require('@/assets/images/NewSelf_Logo.png')"
                            sizes="(max-width: 479px) 100vw, 84.03125px"
                            :srcset="`${require('@/assets/images/NewSelf_Logo-p-500.png')} 500w, ${require('@/assets/images/NewSelf_Logo-p-800.png')} 800w`"
                            loading="lazy" class="image-294">
                    </a>
                    <div class="form-nav-div">
                        <a href="#" @click.prevent="goBack()"
                            class="back-link w-inline-block">
                            <div class="text-block-507">&lt;-</div>
                        </a>
                        <div class="form-progress-div">
                            <div>
                                <div class="text-block-508">Step <strong>1</strong> of <strong>3</strong> Pre-Qualify
                                </div>
                            </div>
                            <div class="form-precent-div">
                                <div class="text-block-509"><strong>{{ Math.round(((questionId - 1) / 11) * 100)
                                        }}%</strong> Complete</div>
                            </div>
                        </div>
                    </div>
                    <div class="div-block-1442">
                        <div class="text-block-505"></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section-7">
            <div class="questions-div">
                <!-- Question 1: Name -->
                <div class="question-container" v-if="questionId === 1">
                    <div class="question-div-2">
                        <div class="text-block-513">Who do I have the pleasure of talking to?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="div-block-1476">
                                    <input class="text-field-43 w-input" maxlength="256" v-model="people.first_name"
                                        placeholder="First Name" type="text" required>
                                    <input class="text-field-43 w-input" maxlength="256" v-model="people.last_name"
                                        placeholder="Last Name" type="text" required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Question 2: Gender -->
                <div class="question-container" v-if="questionId === 2">
                    <div class="question-div-2">
                        <div class="text-block-513">What was your gender at birth?</div>
                        <div class="form-subs">This will help our doctors recommend the proper medications and dosages.
                        </div>
                        <div class="felix-form-block w-form">
                            <a href="#" @click.prevent="setValue('gender', 'Female')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d8197d38318417c44d9c4_Female.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Female</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                            <a href="#" @click.prevent="setValue('gender', 'Male')"
                                class="link-block-30 w-inline-block">
                                <div>
                                    <img src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d81974f75b229e7b38302_Male.svg"
                                        class="image-307" loading="lazy">
                                    <div class="text-block-545">Male</div>
                                </div>
                                <div>
                                    <div class="text-block-546">-></div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>

                <!-- Question 3: Pregnent Or brest feeding -->
                <div class="question-container" v-if="questionId === 3">
                    <div class="question-div-2">
                        <div class="text-block-513">Are you pregnent or breastfeeding?</div>
                        <div class="form-subs">This will help our doctors recommend the proper medications and dosages.
                        </div>
                        <div class="felix-form-block w-form">
                            <a href="#"
                                    @click.prevent="setValue('breastfeeding', 'Yes')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">Yes</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                                <a href="#"
                                    @click.prevent="setValue('breastfeeding', 'No')"
                                    class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545">No</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                        </div>
                    </div>
                </div>

                <!-- Question 4: Date of Birth -->
                <div class="question-container" v-if="questionId === 4">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your date of birth?</div>
                        <div class="form-subs">Based on your date of birth our doctors can prescribe the proper
                            prescription.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateDOB">
                                <div class="div-block-1470 mobile-entry form _2 birth">
                                    <select v-model="people.dob.mm" class="select-field-5 felix w-select" required>
                                        <option value="">Month</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>
                                    <div class="text-block-518">-</div>
                                    <input class="phone-number-field-3 form birth felix w-input" maxlength="2"
                                        pattern="[0-9]*" v-model="people.dob.dd" placeholder="Day" type="text" required>
                                    <div class="text-block-518">-</div>
                                    <input class="phone-number-field-3 _2 form birth felix w-input" maxlength="4"
                                        pattern="[0-9]*" v-model="people.dob.yyyy" placeholder="Year" type="text"
                                        required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                <!-- Question 5: Height and Weight -->
                <div class="question-container" v-if="questionId === 5">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your height and weight?</div>
                        <div class="form-subs">We'll use this to determine your Body mass Index (BMI) for diagnosis.
                            remember, BMI is a measure of size - not health</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="calculateBMI">
                                <div class="div-block-1478 mobile-entry form _2 height top">
                                    <input class="text-field-44 height w-input" maxlength="256"
                                        v-model="people.height.ft" placeholder="Feet" type="text" required>
                                    <input class="text-field-44 height w-input" maxlength="256"
                                        v-model="people.height.inch" placeholder="Inches" type="text" required>
                                </div>
                                <div class="div-block-1479 mobile-entry form _2 weight">
                                    <input class="text-field-45 weight w-input" maxlength="256" v-model="people.weight"
                                        placeholder="Weight in pounds" type="text" required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 6: Symptoms to Treat -->
                <div class="question-container" v-if="questionId === 6">
                    <div class="question-div-2">
                        <div class="text-block-513">What symptoms would you like to treat?</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkSymptoms">
                                <!-- Male Symptoms -->
                                <div class="multi-choice-boxes-div" v-if="people.gender === 'Male'">
                                    <label v-for="(symptom, index) in maleSymptoms" :key="'male-' + index"
                                        class="w-checkbox checkbox-field-multibox">
                                        <div :class="[
                                            'w-checkbox-input',
                                            'w-checkbox-input--inputType-custom',
                                            'checkbox-13',
                                            { 'w--redirected-checked': people.symptoms.includes(symptom.label) }
                                        ]"></div>
                                        <input type="checkbox" :id="'checkbox-' + index" :name="'checkbox-' + index"
                                            :data-name="'Checkbox ' + index" v-model="people.symptoms"
                                            :value="symptom.label" style="opacity:0;position:absolute;z-index:-1">
                                        <img :src="require(`@/assets/images/${symptom.icon}`)" loading="lazy" alt=""
                                            class="image-384">
                                        <span class="checkbox-label-14-check w-form-label" :for="'checkbox-' + index">
                                            {{ symptom.label }}
                                            <span v-if="symptom.subLabel" class="text-span-178">({{ symptom.subLabel
                                                }})</span>
                                        </span>
                                    </label>
                                </div>

                                <!-- Female Symptoms -->
                                <div class="multi-choice-boxes-div" v-if="people.gender === 'Female'">
                                    <label v-for="(symptom, index) in femaleSymptoms" :key="'female-' + index"
                                        class="w-checkbox checkbox-field-multibox">
                                        <div :class="[
                                            'w-checkbox-input',
                                            'w-checkbox-input--inputType-custom',
                                            'checkbox-13',
                                            { 'w--redirected-checked': people.symptoms.includes(symptom.label) }
                                        ]"></div>
                                        <input type="checkbox" :id="'checkbox-' + index" :name="'checkbox-' + index"
                                            :data-name="'Checkbox ' + index" v-model="people.symptoms"
                                            :value="symptom.label" style="opacity:0;position:absolute;z-index:-1">
                                        <img :src="require(`@/assets/images/${symptom.icon}`)" loading="lazy" alt=""
                                            class="image-384">
                                        <span class="checkbox-label-14-check w-form-label" :for="'checkbox-' + index">
                                            {{ symptom.label }}
                                            <span v-if="symptom.subLabel" class="text-span-178">({{ symptom.subLabel
                                                }})</span>
                                        </span>
                                    </label>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 7: Pregnent Or brest feeding -->
                <div class="question-container" v-if="questionId === 7">
                    <div class="question-div-2">
                        <div class="text-block-513">Which areas of health improvement are most important to you? (Select all that apply)</div>
                        <div class="form-subs"></div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkHealthGoals">
                                <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="med in areaofhealth" :key="med">
                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" :value="med" data-name="Checkbox 3" v-model="people.health_improvement" class="w-checkbox-input checkbox-11">
                                    <span class="checkbox-label-12 w-form-label" for="checkbox-3" v-html="med"></span>
                                </label>

                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>
                
                <!-- Question 8: Pregnent Or brest feeding -->
                <div class="question-container" v-if="questionId === 8">
                    <div class="question-div-2">
                        <div class="text-block-513">How active are you throughout the day?</div>
                        <div class="form-subs"></div>
                        <div class="felix-form-block w-form">
                            <a href="#" @click.prevent="setValue('activity_level', 'Very Active (Exercise daily or have a physically demanding job)')" class="link-block-30 w-inline-block">
                                <div class="div-block-1507"><img loading="lazy" src="@/assets/images/icon_level-4.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-571">Very active</div>
                                        <p class="paragraph-109">Exercise daily or have a physically demanding job</p>
                                    </div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('activity_level', 'Moderately Active (Exercise a few times a week, active lifestyle)')" class="link-block-30 w-inline-block">
                                    <div class="div-block-1507"><img loading="lazy" src="@/assets/images/icon_level-3.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-571">Moderately active</div>
                                        <p class="paragraph-109">Exercise a few times a week, active lifestyle</p>
                                    </div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('activity_level', 'Lightly Active (Occasional exercise, mostly sedentary but move around)')" class="link-block-30 w-inline-block">
                                    <div class="div-block-1507"><img loading="lazy" src="@/assets/images/icon_level-2.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-571">Lightly active</div>
                                        <p class="paragraph-109">Occasional exercise, mostly sedentary but move aroundk</p>
                                    </div>
                                    </div>
                                </a>
                                <a href="#" @click.prevent="setValue('activity_level', 'Sedentary (Little to no physical activity most days)')" class="link-block-30 w-inline-block">
                                    <div class="div-block-1507"><img loading="lazy" src="@/assets/images/icon_level.svg" alt="" class="image-313">
                                    <div>
                                        <div class="text-block-571">Sedentary</div>
                                        <p class="paragraph-109">Little to no physical activity most days</p>
                                    </div>
                                    </div>
                                </a>
                        </div>
                    </div>
                </div>

                <!-- Question 16: State Selection -->
                <div class="question-container" v-if="questionId === 9">
                    <div class="question-div-2">
                        <div class="text-block-513">What state do you reside in?</div>
                        <div class="form-subs">We need to match you to a licensed clinician in your state.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="checkState">
                                <select v-model="people.state" required class="select-field-7 form w-select">
                                    <option value="" disabled selected>State...</option>
                                    <option v-for="(value, key) in allstate" :key="key" :value="value">{{ key }}
                                    </option>
                                </select>
                                <input type="submit" class="form-button w-button" value="Next ->">
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 17: Phone Number -->
                <div class="question-container" v-if="questionId === 10">
                    <div class="question-div-2">
                        <div class="text-block-513">What is your mobile phone number?</div>
                        <div class="form-subs">Enter the best phone to reach you on just in case your doctor has any
                            questions regarding your medical information.</div>
                        <div class="checks-div">
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Updates from your doctor</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Shipping notifications</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Prescription alerts</div>
                            </div>
                            <div class="bullet-div">
                                <img loading="lazy" src="@/assets/images/icon_check_purp.svg" alt="" class="image-303">
                                <div class="text-block-540">Latest offers from NewSelf</div>
                            </div>
                        </div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="nextQuestion">
                                <div class="phone-entry-div felix">
                                    <input class="phone-number-field-3 _1 form w-input" pattern="[0-9]*" maxlength="3"
                                        minlength="3" @keyup="focusNext" v-model="people.phone_part.part1"
                                        placeholder="(000)" type="text" required>
                                    <div class="text-block-539">-</div>
                                    <input class="phone-number-field-3 form w-input" pattern="[0-9]*" maxlength="3"
                                        minlength="3" @keyup="focusNext" v-model="people.phone_part.part2"
                                        placeholder="000" type="text" required>
                                    <div class="text-block-539">-</div>
                                    <input class="phone-number-field-3 _2 form w-input" pattern="[0-9]*" maxlength="4"
                                        minlength="4" @keyup="focusNext" v-model="people.phone_part.part3"
                                        placeholder="0000" type="text" required>
                                </div>
                                <input type="submit" class="form-button w-button" value="Next ->">
                                <p class="paragraph-103">
                                    By clicking "Next," you agree to receive communications from NewSelf, including
                                    AI-generated calls, automated dialing systems, text messages,
                                    emails, and other communication methods, to the contact information provided. These
                                    communications may include promotions, updates, and
                                    follow-up information related to your inquiry or our services. Standard message and
                                    data rates may apply. You can opt-out at any time. For more
                                    details, please review our <a href="https://joinyara.com/privacy-policy-new"
                                        target="_blank">Privacy Policy</a>.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>

                <!-- Question 18: Email -->
                <div class="question-container" v-if="questionId === 11">
                    <div class="question-div-2">
                        <div class="text-block-513">Please enter your email</div>
                        <div class="form-subs">We will send you confirmation of approval & discount offers.</div>
                        <div class="felix-form-block w-form">
                            <form @submit.prevent="validateEmail">
                                <input class="text-field-47 email form w-input" maxlength="256" v-model="people.email"
                                    placeholder="Enter your email" type="email" :class="{ 'text-danger': isError }"
                                    required>
                                <button class="form-button w-button" :disabled="loading" style="padding-top: 15px;">
                                    <div class="div-block-817" v-if="loading">
                                        <img src="@/assets/images/submitted.svg">
                                    </div>
                                    <div class="div-block-817" v-else>
                                        <div class="text-block-199">Next -></div>
                                    </div>
                                </button>
                                <p class="paragraph-103">
                                    By clicking "Next," you agree to receive communications from NewSelf, including
                                    AI-generated calls, automated dialing systems, text messages,
                                    emails, and other communication methods, to the contact information provided. These
                                    communications may include promotions, updates, and
                                    follow-up information related to your inquiry or our services. Standard message and
                                    data rates may apply. You can opt-out at any time. For more
                                    details, please review our <a href="https://joinyara.com/privacy-policy-new"
                                        target="_blank">Privacy Policy</a>.
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div style="height: 320px;"></div>
    </div>
</template>

<script>
import state from "@/utils/state.json"

export default {
    name: 'HealthOptimizationQuiz',
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            allstate: state,
            questionId: 1,
            isError: false,
            loading: false,
            areaofhealth:[
                "Longevity & Vitality", 
                "Enhanced Mental Clarity & Focus",
                "Increased Energy & Stamina", 
                "Weight Loss & Body Composition", 
                "Boosted Sexual Health & Libido", 
                "Healthier Skin & Hair)",
                "Optimized Digestive & Gut Health"
            ],
            doses: [
                { phase: 1, dose: 2.5 },
                { phase: 2, dose: 5 },
                { phase: 3, dose: 7.5 },
                { phase: 4, dose: 10 },
                { phase: 5, dose: 12.5 },
                { phase: 6, dose: 15 }
            ],
            people: {
                id: '',
                first_name: '',
                last_name: '',
                gender: 'Male',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
                height: {
                    ft: '',
                    inch: ''
                },
                weight: '',
                heightInInches:'',
                dobMMDDYYYY:'',
                bmi:'',
                age:'',
                breastfeeding:'',
                activity_level:'',
                health_improvement:[],
                state: '',
                phone_part: {
                    part1: '',
                    part2: '',
                    part3: ''
                },
                email: '',
                ip_address: '',
                aff_id: '',
                tid: '',
                utm_source: '',
                utm_medium: '',
                utm_campaign: '',
                utm_content: '',
                utm_term: '',
                symptoms:[],
                form_type: 'onboarding',
            },
            maleSymptoms: [
                { label: 'Brain Fog, Difficulty Focusing', icon: 'icon_-Brain.svg' },
                { label: 'Low Energy', icon: 'icon_-low-Energy.svg' },
                { label: 'Difficulty Losing Weight', icon: 'Lose-Weight.svg' },
                { label: 'Increased Body Fat', subLabel: 'especially around the abdomen', icon: 'icon_-Body-Fat.svg' },
                { label: 'Muscle Weakness or Loss', subLabel: 'including reduced strength', icon: 'icon_-Weak.svg' },
                { label: 'Decreased Endurance', subLabel: 'physical and sexual stamina', icon: 'icon_-No-Endurance.svg' },
                { label: 'Low Libido or Erectile Dysfunction', subLabel: 'ED', icon: 'icon_-Libido.svg' },
                { label: 'Hair Thinning or Hair Loss', icon: 'icon_-Hair-Loss.svg' },
                { label: 'Poor Skin Quality', subLabel: 'wrinkles, sagging, dryness', icon: 'icon_-Skin.svg' },
                { label: 'Sleep Issues', subLabel: 'difficulty falling or staying asleep', icon: 'icon_-Sleep.svg' },
                { label: 'Mood Swings, Anxiety, or Irritability', icon: 'icon_-Anxiety.svg' },
                { label: 'Joint Pain or Stiffness', icon: 'icon_-Joint-Pain.svg' },
                { label: 'Digestive Problems', subLabel: 'bloating, irregularity', icon: 'icon_-Digestive.svg' },
                { label: 'Cold Hands and Feet', subLabel: 'could indicate slow metabolism', icon: 'icon_-Cold-Hand.svg' },
                { label: 'Urinary Issues', subLabel: 'e.g., frequency, urgency', icon: 'icon_-Urinary.svg' }
            ],
            femaleSymptoms: [
                { label: 'Brain Fog, Difficulty Focusing', icon: 'icon_-Brain.svg' },
                { label: 'Low Energy', icon: 'icon_-low-Energy.svg' },
                { label: 'Difficulty Losing Weight', icon: 'Lose-Weight.svg' },
                { label: 'Increased Body Fat', subLabel: 'especially around the abdomen', icon: 'icon_-Body-Fat.svg' },
                { label: 'Muscle Weakness or Loss', subLabel: 'including reduced strength', icon: 'icon_-Weak.svg' },
                { label: 'Hair Thinning or Hair Loss', icon: 'icon_-Hair-Loss.svg' },
                { label: 'Poor Skin Quality', subLabel: 'wrinkles, sagging, dryness', icon: 'icon_-Skin.svg' },
                { label: 'Mood Swings, Anxiety, or Irritability', icon: 'icon_-Anxiety.svg' },
                { label: 'Sleep Issues', subLabel: 'difficulty falling or staying asleep', icon: 'icon_-Sleep.svg' },
                { label: 'Hot Flashes/Night Sweats', icon: 'icon_-Sweats.svg' },
                { label: 'Joint Pain or Stiffness', icon: 'icon_-Joint-Pain.svg' },
                { label: 'Digestive Problems', subLabel: 'bloating, irregularity', icon: 'icon_-Digestive.svg' },
                { label: 'Vaginal Dryness', icon: 'icon_-Vdryness.svg' },
                { label: 'Swollen or Tender Breasts', icon: 'icon_-Breast.svg' },
                { label: 'Urinary Issues', subLabel: 'e.g., frequency, urgency', icon: 'icon_-Urinary.svg' },
                { label: 'Cold Hands and Feet', subLabel: 'could indicate slow metabolism', icon: 'icon_-Cold-Hand.svg' },
                { label: 'Increased Stress Levels', icon: 'icon_-stress.svg' }
            ]
        }
    },
    computed:{
        
    },
    methods: {
        goBack(){
            if(this.questionId > 1){
                if(this.questionId==4 && this.people.gender==='Male'){
                    this.questionId-=2;
                }else{
                    this.questionId--;
                }
            }
        },
        nextQuestion() {
            this.questionId++
            this.scrolltoTop()
        },
        setValue(field, value) {
            this.people[field] = value
            if (field === 'currently_taking_glp' && value === 'No') {
                this.questionId += 3
            } else if (field === 'want_coach') {
                this.moveToCheckout()
            }else if(field==='gender' && value==='Male'){
                this.questionId += 2;
            } else {
                this.nextQuestion()
            }
        },
        validateDOB() {
            const { mm, dd, yyyy } = this.people.dob
            if (!this.isValidDate(mm, dd, yyyy)) {
                this.isError = true
                return
            }
            const today = new Date()
            const birthDate = new Date(yyyy, mm - 1, dd)
            let age = today.getFullYear() - birthDate.getFullYear()
            const monthDiff = today.getMonth() - birthDate.getMonth()
            
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--
            }
            this.people.dobMMDDYYYY= `${mm}/${dd}/${yyyy}`
            this.people.age = age;
            this.nextQuestion();
            this.isError = false
        },
        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day)
            return date instanceof Date && !isNaN(date) &&
                   date.getMonth() === month - 1 &&
                   date.getDate() === parseInt(day) &&
                   date.getFullYear() === parseInt(year)
        },
        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.ft) * 12) + parseInt(this.people.height.inch)
            const weightInPounds = parseInt(this.people.weight)
            const bmi = (weightInPounds * 703) / (heightInInches * heightInInches)
            this.people.bmi = bmi.toFixed(2);
            this.people.heightInInches = heightInInches;
            this.nextQuestion()
        },
        checkSymptoms(){
            if (this.people.symptoms.length > 0) {
                this.nextQuestion()
            }
        },
        checkHealthGoals() {
            if (this.people.health_improvement.length > 0) {
                this.nextQuestion()
            }
        },
        checkState() {
            this.nextQuestion()
        },
        disqualifiedLead() {
            this.$router.push({ name: 'leadDisqualified' })
        },
        focusNext(event) {
            const currentInput = event.target
            const nextInput = currentInput.nextElementSibling?.nextElementSibling
            const prevInput = currentInput.previousElementSibling?.previousElementSibling

            if (event.key === "Backspace" && currentInput.value === "" && prevInput) {
                prevInput.focus()
            } else if (currentInput.value.length === currentInput.maxLength && nextInput) {
                nextInput.focus()
            }
        },
        validateEmail() {
            this.isError = false
            this.people.phone = this.people.phone_part.part1 + this.people.phone_part.part2 + this.people.phone_part.part3
            this.people.email = this.people.email.toLowerCase();
            if (!this.isEmailValid(this.people.email)) {
                this.isError = true
                return
            }
            this.submitForm();
        },
        isEmailValid(email) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9]{2,}$/
            return regex.test(email)
        },
        async submitForm() {
            try {
                this.loading = true
                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                if (response.data.status === 'success') {
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    if(this.$route.query.page_ref){
                        this.$router.push({ name: this.$route.query.page_ref });
                    }else{
                        this.$router.replace("/store");
                    }
                }
            } catch (error) {
                console.error('Error submitting form:', error)
                alert("An Internal error occurred")
            } finally {
                this.loading = false
            }
        },
        checkUrlParameters() {
            const urlParams = new URLSearchParams(window.location.search)
            urlParams.forEach((value, key) => {
                this.people[key] = value
            })
            const phone = urlParams.get('phone')
            if (phone) {
                this.people.phone = phone
                this.people.phone_part = {
                    part1: phone.slice(0, 3),
                    part2: phone.slice(3, 6),
                    part3: phone.slice(6)
                }
            }
            this.getAffiliate()
        },
        getCookie(name) {
            const value = `; ${document.cookie}`
            const parts = value.split(`; ${name}=`)
            return parts.length === 2 ? parts.pop().split(';').shift() : null
        },
        getQueryParamOrCookie(url, paramName) {
            const params = new URLSearchParams(new URL(url).search)
            return params.get(paramName) || this.getCookie(paramName)
        },
        getAffiliate() {
            const url = window.location.href
            const keys = ['utm_campaign', 'tid', 'utm_source', 'utm_term', 'utm_medium', 'utm_content']
            keys.forEach(key => {
                const value = this.getQueryParamOrCookie(url, key)
                if (value) {
                    this.people[key] = value
                    if (key === 'utm_campaign') this.people.aff_id = value
                }
            })
        },
        getIPAddress() {
            try {
                this.people.ip_address = this.$store.getters.ipAddress
            } catch (error) {
                console.error('Error getting IP address:', error)
            }
        },
        scrolltoTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        }
    },
    mounted() {
        this.checkUrlParameters()
        this.scrolltoTop()
        this.getIPAddress()
    },
    watch: {
        questionId() {
            this.scrolltoTop()
        }
    }
}
</script>
<style scoped>
.multi-choice-boxes-div {
    justify-content: space-between;
    align-items: stretch;
    margin-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
}

.checkbox-field-multibox {
    border: 1px solid #000;
    border-radius: 9px;
    flex-flow: column;
    justify-content: flex-start;
    align-items: center;
    width: 48%;
    height: 160px;
    padding: 19px 13px;
    display: flex;
    position: relative;
    overflow: hidden;
    margin-bottom: 20px;
}

.checkbox-13-check {
    border: 1px #000;
    width: 100%;
    height: 100%;
    margin-top: 0;
    margin-left: 0;
    position: absolute;
    inset: 0%;
}

.image-384 {
    width: 55px;
    height: 55px;
    margin-bottom: 10px;
    position: relative;
}

.checkbox-label-14-check {
    font-family: var(--mulish);
    color: var(--black);
    text-align: center;
    margin-top: 0;
    font-size: 15px;
    font-weight: 600;
    line-height: 15px;
    position: relative;
}

.w-checkbox:after {
    content: " ";
    clear: both;
    grid-area: 1 / 1 / 2 / 2;
    display: table;
}

/* Add mobile responsiveness */
@media screen and (max-width: 479px) {
    .checkbox-field-multibox {
        width: 100%;
        margin-bottom: 10px;
    }
}
</style>